import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RestS } from "../../rest/rest-service";
import {
  missingCostItemsInf,
  missingProductCostsInf,
} from "../../interfaces/interfaces";

export const getMissingCostItemsThunk = createAsyncThunk(
  "finance/getMissingCostItems",
  async (companyId, { rejectWithValue }) => {
    try {
      const response: any = await RestS.getMissingCostItems();
      return response;
    } catch (err) {
      return rejectWithValue(err ? err : "something went wrong");
    }
  }
);

export const fetchProductMissingCosts = createAsyncThunk(
  "finance/fetchProductMissingCosts",
  async (product, { rejectWithValue }) => {
    try {
      const response: any = await RestS.fetchProductMissingCosts();
      return response;
    } catch (err) {
      return rejectWithValue(err ? err : "something went wrong");
    }
  }
);

interface FinanceStateRedux {
  refreshFinanceStatement: boolean;
  refreshPcHome: boolean;
  refreshAccountUpdate: boolean;
  refreshAccountFetching: boolean;
  closeBulkModal: boolean;
  missingCostItems: missingCostItemsInf;
  missingProductCosts: missingProductCostsInf;
  bulkUpdateInProgress: boolean;
}

const INITIAL_STATE: FinanceStateRedux = {
  refreshFinanceStatement: false,
  refreshPcHome: false,
  refreshAccountUpdate: false,
  refreshAccountFetching: false,
  closeBulkModal: false,
  missingCostItems: {
    missingCounts: 0,
    missingSections: [],
    items: [],
    lastMonth: "",
  },
  missingProductCosts: {
    productCount: 0,
    missingCostCount: 0,
    status: "FETCHING",
  },
  bulkUpdateInProgress: false,
};

const financeStatement = createSlice({
  name: "financeStatement",
  initialState: INITIAL_STATE,
  reducers: {
    setRefreshFinanceStatement: (state, actions) => {
      state.refreshFinanceStatement = actions.payload;
    },
    setRefreshPcHome: (state, actions) => {
      state.refreshPcHome = actions.payload;
    },
    setRefreshAccountUpdate: (state, actions) => {
      state.refreshAccountUpdate = actions.payload;
    },
    setRefreshAccountFetching: (state, actions) => {
      state.refreshAccountFetching = actions.payload;
    },
    setCloseBulkModal: (state, actions) => {
      state.closeBulkModal = actions.payload;
    },
    setBulkUpdateStatus: (state, actions) => {
      state.bulkUpdateInProgress = actions.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMissingCostItemsThunk.fulfilled, (state, action) => {
      state.missingCostItems = action.payload;
    });
    builder.addCase(fetchProductMissingCosts.pending, (state) => {
      state.missingProductCosts.status = "FETCHING";
    });
    builder.addCase(fetchProductMissingCosts.fulfilled, (state, action) => {
      state.missingProductCosts = action.payload;
    });
  },
});

export const {
  setRefreshFinanceStatement,
  setRefreshPcHome,
  setRefreshAccountUpdate,
  setRefreshAccountFetching,
  setCloseBulkModal,
  setBulkUpdateStatus,
} = financeStatement.actions;

export const financeStatementReducer = financeStatement.reducer;
